import dayjs, { Dayjs } from 'dayjs';

export const formatDateTime = (date: string | null | Date | undefined | Dayjs) => dayjs(date).format('D MMM YYYY H:mm');

export const formatDate = (date: string | null | Date | undefined | Dayjs) => dayjs(date).format('D MMM YYYY');

export const formatTime = (date: string | null | Date | undefined | Dayjs) => dayjs(date).format('HH:mm');
